'use client';
import styled from 'styled-components';

export const StyledLoginContainer = styled.main`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
  background: ${({ theme }) => theme.colors.background.base};
`;

export const LoginContainer = styled.div`
  flex-grow: 1;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  max-width: 650px;
  padding: ${({ theme }) => theme.spacing(0, 6)};
  border-radius: 35px;
  margin-bottom: ${({ theme }) => theme.spacing(16)};
  margin-top: ${({ theme }) => theme.spacing(16)};
  background-color: ${({ theme }) => theme.colors.background.lightest};
`;

export const ContainerWrapper = styled.div`
  width: 100%;
  align-items: center;
  text-align: center;
  margin: 0 auto;
  flex-grow: 1;
  display: flex;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing(12)};
  margin-bottom: ${({ theme }) => theme.spacing(12)};
  max-width: 336px;
`;
